import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QuotationProvider } from './context/QuotationContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QuotationProvider>
      <App />
    </QuotationProvider>
  </React.StrictMode>
);

// Register service worker for offline support and caching
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('✅ Service Worker: Content cached for offline use');
  },
  onUpdate: (registration) => {
    console.log('🎉 Service Worker: New content available!');
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
